import React, {useEffect, useMemo, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import BaseCard from "../baseCard";
import {useQuery} from "@apollo/react-hooks";
import {GET_ACCOUNTS} from "../../../database/queries/accountQueries";
import CalendarStrings from "../../../constants/calendarStrings";
import Moment from "react-moment";
import {AutoSizer} from 'react-virtualized';
import {notify} from "../../../utils/notify";
import {Link, useRouteMatch} from "react-router-dom";
import ExpandedTable from "../../Common/ExpandedTable/expandedTable";
import {isEqual} from "lodash";
import usePersistentStore from "../../../persistentStore";

const useStyles = makeStyles({
    root: {},
});

const AccountsCard = props => {
    const classes = useStyles();
    const [accounts, setAccounts] = useState([]);
    const [accountCount, setAccountCount] = useState(0);
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [orderList, setOrderList] = useState();
    const [skipPageReset, setSkipPageReset] = useState(false)
    let {url} = useRouteMatch();

    const columns = useMemo(
        () => [
            {
                id: 'displayName',
                Header: 'Name',
                accessor: r => {
                    return (
                        <Link to={`/accounts/${r.accountId}`}
                              onClick={() => globalPersistentActions.setDetailTabsTitle(r.displayName)}
                        >
                            {r.displayName}
                        </Link>
                    );
                },
                sortFields: ['accountName']
            },
            {
                id: 'accountLinkedinId',
                Header: 'Linkedin Id',
                accessor: r => {
                    if (r.accountLinkedinId) {
                        return <a href={'https://linkedin.com/in/' + r.accountLinkedinId}
                                  target={"_blank"} rel="noopener noreferrer">{r.accountLinkedinId}</a>
                    } else {
                        return ""
                    }
                },
                sortFields: ['accountLinkedinId']
            },
            {
                id: 'updatedAt',
                Header: 'Last Updated',
                accessor: r => <Moment calendar={CalendarStrings}>{r.updatedAt}</Moment>,
                sortFields: ['updatedAt']
            },
            {
                id: 'tags',
                Header: 'Tags',
                accessor: r => {
                    return <span>{r.tags.map(tag => tag.tag).join(', ')}</span>
                },
                disableSortBy: true,
            }
        ],
        [url]
    )

    const {
        loading: getAccountsLoading,
        error: getAccountsError,
        data: getAccountsData,
        refetch: getAccountsRefetch
    } = useQuery(GET_ACCOUNTS, {
        fetchPolicy: "no-cache",
        variables: {
            // searchStr: searchStr,
            // filterSQL: filter ? filter.filterSQL : null,
            limit: pageSize,
            offset: pageIndex * pageSize,
            orderList: orderList
        },
    });

    useEffect(() => {
        console.log('getAccountsData', getAccountsData);
        if (getAccountsData) {
            setAccounts(getAccountsData.accounts.rows);
            setAccountCount(getAccountsData.accounts.count);
        }
    }, [getAccountsData]);

    useEffect(() => {
        if (getAccountsError) notify('getAccountsError', 'error', getAccountsError.message);
    }, [getAccountsError]);

    const getOrderList = (sortBy) => {
        let orderList = [];
        if (sortBy && sortBy.length > 0) {
            for (let s = 0; s < sortBy.length; s++) {
                const sortFld = sortBy[s];
                const sortDir = sortFld.desc ? 'DESC' : 'ASC';
                const sortCol = columns.filter(column => column.id === sortFld.id);
                if (sortCol && sortCol.length > 0) {
                    const sortFields = sortCol[0].sortFields;
                    if (sortFields) {
                        for (let f = 0; f < sortFields.length; f++) {
                            orderList.push(`${sortFields[f]} ${sortDir}`);
                        }
                    }
                }
            }
        }
        return orderList;
    }

    const getData = (newPageIndex, newPageSize, newSortBy) => {
        const newOrderList = getOrderList(newSortBy);
        if (!isEqual(orderList, newOrderList)) setOrderList(newOrderList);
        if (newPageSize !== pageSize) setPageSize(newPageSize);
        if (newPageIndex !== pageIndex) setPageIndex(newPageIndex);
        getAccountsRefetch();
    }

    if (getAccountsLoading) return <p>Loading ...</p>;
    if (getAccountsError) return `Error! ${getAccountsError.message}`;

    return (
        <AutoSizer>
            {({height, width}) => {
                return (
                    <BaseCard title={"Recent Accounts"} height={height} width={width}>
                        <div className={classes.root}>
                            {accounts && (<ExpandedTable
                                height={height - 50}
                                columns={columns}
                                data={accounts}
                                dataCount={accountCount}
                                getData={getData}
                                pageSize={pageSize}
                                pageIndex={pageIndex}
                                skipPageReset={skipPageReset}
                                setSkipPageReset={setSkipPageReset}
                                hideRowsPerPage={true}
                                getRowId={row => row.accountId}
                                testFieldName={"accountName"}
                            />)}
                        </div>
                    </BaseCard>
                );
            }}
        </AutoSizer>
    );
};

export default AccountsCard
